// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleInput_root__278Q5","inputContainer":"ToggleInput_inputContainer__1WChr","switch":"ToggleInput_switch__2pREm","checked":"ToggleInput_checked__1mtjZ"};